"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _modal = _interopRequireDefault(require("antd/lib/modal"));
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = _interopRequireDefault(require("lodash.throttle"));
var _configProvider = require("../config-provider");
var _nanoid = _interopRequireDefault(require("../_utils/nanoid"));
var _WrongIcon = _interopRequireDefault(require("../_assets/WrongIcon"));
var _observerUtil = require("../_utils/observerUtil");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/**
 * 这里的值，需要和modal.less中的max-height保持一致
 * 不用style内联的方式，是为了避免对项目中有自定义样式的modal造成影响
 */
var MAX_HEIGHT = 0.8;
var MAX_HEIGHT_THRESHOLD = 20;
var SHADOW_THRESHOLD = 2;
var sizeWidth = {
  large: 700,
  middle: 520,
  small: 420
};
var closeIcon = /*#__PURE__*/_react["default"].createElement("span", {
  className: "anticon"
}, /*#__PURE__*/_react["default"].createElement(_WrongIcon["default"], null));
var Modal = function Modal(_a) {
  var _a$autoLoading = _a.autoLoading,
    autoLoading = _a$autoLoading === void 0 ? false : _a$autoLoading,
    _a$enableMaxHeight = _a.enableMaxHeight,
    enableMaxHeight = _a$enableMaxHeight === void 0 ? true : _a$enableMaxHeight,
    _a$centered = _a.centered,
    centered = _a$centered === void 0 ? true : _a$centered,
    className = _a.className,
    wrapClassName = _a.wrapClassName,
    propLoading = _a.confirmLoading,
    open = _a.open,
    visible = _a.visible,
    _a$size = _a.size,
    size = _a$size === void 0 ? 'middle' : _a$size,
    width = _a.width,
    _a$showShadow = _a.showShadow,
    showShadow = _a$showShadow === void 0 ? true : _a$showShadow,
    prefixCls = _a.prefixCls,
    propOnOk = _a.onOk,
    propOnCancel = _a.onCancel,
    restProps = __rest(_a, ["autoLoading", "enableMaxHeight", "centered", "className", "wrapClassName", "confirmLoading", "open", "visible", "size", "width", "showShadow", "prefixCls", "onOk", "onCancel"]);
  var _useState = (0, _react.useState)(propLoading),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var modalOpen = open || visible;
  var modalId = (0, _react.useRef)((0, _nanoid["default"])());
  // 一个页面上可能存在多个Modal，通过此className选中当前Modal元素
  var modalWrapClassName = "ant-modal-wrap-".concat(modalId.current);
  var wrapClassNameExtended = (0, _classnames["default"])(wrapClassName, modalWrapClassName);
  var _useState3 = (0, _react.useState)(true),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    exceedMaxHeight = _useState4[0],
    setExceedMaxHeight = _useState4[1];
  var _useState5 = (0, _react.useState)(true),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    scrollPositionTop = _useState6[0],
    setScrollPositionTop = _useState6[1];
  var _useState7 = (0, _react.useState)(true),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    scrollPositionBottom = _useState8[0],
    setScrollPositionBottom = _useState8[1];
  var _useContext = (0, _react.useContext)(_configProvider.ConfigContext),
    getPrefixCls = _useContext.getPrefixCls;
  var finalPrefixCls = getPrefixCls('modal', prefixCls);
  var modalClassName = (0, _classnames["default"])(className, {
    'ant-modal--with-maxheight': enableMaxHeight && exceedMaxHeight,
    'ant-modal--with-top-shadow': showShadow && !scrollPositionTop,
    'ant-modal--with-bottom-shadow': showShadow && !scrollPositionBottom
  });
  var finalWidth = typeof width === 'undefined' || width === null ? sizeWidth[size] : width;
  (0, _react.useEffect)(function () {
    if (!autoLoading) {
      // 如果设置了autoLoading，理论上 loading就被内部接管了，props就不该传loading过来，传了也无视
      setLoading(propLoading);
    }
  }, [propLoading]);
  (0, _react.useEffect)(function () {
    if (modalOpen) {
      setTimeout(function () {
        var modalWrapDom = document.querySelector(".".concat(modalWrapClassName));
        var modalDom = modalWrapDom === null || modalWrapDom === void 0 ? void 0 : modalWrapDom.querySelector(".".concat(finalPrefixCls));
        var modalBodyDom = modalWrapDom.querySelector(".".concat(finalPrefixCls, "-body"));
        var setMaxHeight = function setMaxHeight() {
          if ((modalDom === null || modalDom === void 0 ? void 0 : modalDom.offsetHeight) < (modalWrapDom === null || modalWrapDom === void 0 ? void 0 : modalWrapDom.offsetHeight) * MAX_HEIGHT - MAX_HEIGHT_THRESHOLD) {
            // 如果没有达到最大高度，则去除滚动条的样式
            // 原因：加了滚动条样式后，内部的select下拉框如果设置为随滚动条滚动而滚动，就会出现下拉框的高度不能超出滚动区域，可视区域就小了
            // 为了尽量避免这种情况，在没有达到最大高度时，不加载滚动条样式
            setExceedMaxHeight(false);
          } else {
            setExceedMaxHeight(true);
          }
        };
        var setShadow = function setShadow(scrollTop) {
          if (!showShadow) {
            return;
          }
          if (scrollTop <= 0) {
            setScrollPositionTop(true);
          } else {
            setScrollPositionTop(false);
          }
          if (modalBodyDom.clientHeight < modalBodyDom.scrollHeight) {
            if (scrollTop + modalBodyDom.clientHeight < modalBodyDom.scrollHeight - SHADOW_THRESHOLD) {
              setScrollPositionBottom(false);
            } else {
              setScrollPositionBottom(true);
            }
          }
        };
        (0, _observerUtil.observe)(modalBodyDom, function (target) {
          setMaxHeight();
          setShadow(target.scrollTop);
        });
        if (showShadow) {
          modalBodyDom.addEventListener('scroll', (0, _lodash["default"])(function (e) {
            var _a;
            setShadow((_a = e.target) === null || _a === void 0 ? void 0 : _a.scrollTop);
          }, 100));
        }
        setMaxHeight();
        setShadow(modalBodyDom.scrollTop);
      }, 300);
    }
    return function () {
      return (0, _observerUtil.unobserve)(document.querySelector(".".concat(modalWrapClassName, " .").concat(finalPrefixCls, "-body")));
    };
  }, [modalOpen]);
  var onOk = autoLoading ? function (e) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!propOnOk) {
              _context.next = 8;
              break;
            }
            setLoading(true);
            _context.prev = 2;
            _context.next = 5;
            return propOnOk(e);
          case 5:
            _context.prev = 5;
            setLoading(false);
            return _context.finish(5);
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2,, 5, 8]]);
    }));
  } : propOnOk;
  var onCancel = autoLoading ? function (e) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (propOnCancel) {
              propOnCancel(e);
            }
            setLoading(false);
          // 关闭弹窗时停止loading
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
  } : propOnCancel;
  return /*#__PURE__*/_react["default"].createElement(_modal["default"], (0, _extends2["default"])({
    confirmLoading: loading,
    wrapClassName: wrapClassNameExtended,
    className: modalClassName,
    centered: centered,
    closeIcon: closeIcon,
    onOk: onOk,
    onCancel: onCancel,
    width: finalWidth,
    open: modalOpen
  }, restProps));
};
var _default = exports["default"] = Modal;